import { chain, values } from 'ramda';
import createReducer from './createReducer';
import applyMiddleware from './applyMiddleware';
import createStore from './createStore';

export default function buildStore(reducers, operatorRecords, primitives, middleware) {
  const reducer = createReducer(reducers, operatorRecords);
  const records = chain(values, values(operatorRecords)).concat(values(primitives));
  const store = createStore(reducer, applyMiddleware(...middleware));
  store.addRecords(records);
  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js